module.exports = __webpack_public_path__ + "static/media/share-plus.b7dba385.svg";